<div>
    <lib-banner></lib-banner>
    <lib-sidenav [iconSrc]="iconSrc()" [logoSrc]="logoSrc()" [routes]="loggedInRoutes"></lib-sidenav>
    <div class="page-wrapper">
        <router-outlet>
            <div class="loading-spinner" 
                [ngClass]="{ 'active': spinnerStore.isLoading()}">
                <lib-loading-spinner></lib-loading-spinner>
            </div>
        </router-outlet>

    </div>
</div>
<lib-footer [companyName]="siteName"></lib-footer>

